import { styled } from "@mui/material/styles";
import AutocompleteComponent from "@mui/material/Autocomplete";

export const Autocomplete = styled(AutocompleteComponent)`
  .MuiInputBase-colorPrimary {
    border-radius: 8px;
    border: 1px solid rgb(215, 215, 214);
  }
  .MuiAutocomplete-tag {
    max-width: calc(80% - 6px);
  }

  .MuiOutlinedInput-root {
    padding: 0;
  }

  .MuiAutocomplete-endAdornment {
    right: 10px;
  }
`;
